import React, { useEffect, useState } from 'react';
import {
  useMediaQuery,
  Typography,
  Box,
  Card,
  CardContent,
} from '@mui/material';

const PlanTypeIndicator = ({ option }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: option === 1 ? -25 : option === 2 ? 230 : 70,
        right: option === 1 ? -40 : option === 2 ? -40 : -60,
        display: 'flex',
        alignItems: 'center',
        zIndex: -1,
      }}
    >
      <div
        style={{
          width: '114px',
          height: '114px',
          borderRadius: '50%',
          backgroundColor:
            option === 1 ? '#D7F1FD' : option === 2 ? '#DBF7EB' : '#FFEED6',
        }}
      />
    </div>
  );
};

export default function CardPlanCode({ selected, onClick, plan, option }) {
  const priceNum = Number(plan.recurlyPlanCodePrice);
  const montlyPrice = priceNum / 12;

  const professionalBullets = [
    'Join any advisory boards on our platform',
    'Make your Advisor Profile live in our directory',
    'Establish your custom Advisor Rate',
    'Access exclusive tools & resources',
    'Receive advisory role inquiries',
  ];

  const executiveBullets = [
    'Everything from Professional, plus...',
    'Board matching & profile optimization call',
    'Quarterly check-ins & recommendations',
    'Be a featured advisor & increase your exposure',
    'Dedicated contact to handle everything for you',
  ];

  const selectedBullets = option === 1 ? professionalBullets : executiveBullets;
  const headline =
    option === 1
      ? 'Exposure to a world of new senior-level opportunities'
      : 'Makes being on a portfolio of boards easy, exciting and rewarding';

  return (
    <Card
      onClick={onClick}
      sx={{
        width: '320px',
        height: '280px',
        border: '1px solid',
        borderColor: selected ? '#3171F6' : '#C7D0DE',
        borderRadius: '15px',
        cursor: 'pointer',
        position: 'relative',
        zIndex: 1,
        boxShadow: selected ? '0 0 0 2px #3171F6' : 'none',
      }}
    >
      <CardContent>
        <Typography
          sx={{
            color: '#232B35',
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '18px',
            letterSpacing: '-0.43px',
            marginBottom: '10px',
          }}
        >
          {plan.salesforceValues?.tier}
        </Typography>

        <Typography
          sx={{
            color: '#232B35',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '15px',
            letterSpacing: '-0.43px',
            marginBottom: '10px',
          }}
        >
          {headline}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {selectedBullets.map((text, index) => (
            <Typography
              key={index}
              sx={{
                color: '#232B35',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '24px',
                letterSpacing: '-0.43px',
              }}
            >
              ✓ {text}
            </Typography>
          ))}
          <Typography
            sx={{
              color: '#232B35',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '-0.43px',
              marginTop: '10px',
            }}
          >
            Only ${Math.ceil(montlyPrice)}/mo. (Billed annually at $
            {Math.ceil(priceNum)})
          </Typography>
        </Box>
      </CardContent>
      <PlanTypeIndicator option={option} />
    </Card>
  );
}
